module.exports = fox._r("images/lang/sp.png", __webpack_public_path__ + "_/_/_/common/frame/images/lang/sp.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/lang/sp.png
// module id = 112
// module chunks = 2